<script>
import MixGridTile from '@components/mix-grid-tile'

export default {
    components: {
        MixGridTile,
    },
    props: {
        mixes: {
            type: Array,
            default: () => [],
        },
        scroll: {
            type: Boolean,
            default: false,
        },
        scrollMobileOnly: {
            type: Boolean,
            default: false,
        },
        padded: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<template>
    <div
        :class="[
            $style.block,
            scroll && $style.scroll,
            scrollMobileOnly && $style.scrollMobileOnly,
            padded && $style.blockPadded,
        ]"
    >
        <MixGridTile
            v-for="(mix, index) in mixes"
            :key="'mix-grid-tile' + mix.id + index + Math.random()"
            :mix="mix"
            :index="index"
            :class="$style.tile"
        />
    </div>
</template>

<style lang="scss" module>
@import '@design';

// Net inset = 2×gutter padding − 2×negative-margin correction
// gutter() = $size-large-grid-padding (24px), negative margin = $size-grid-padding (12px) each side
// net = 2×24 − 2×12 = 24px — the amount by which actual block width is narrower than the viewport-derived content width.
$_tile-net-inset: 2 * $size-large-grid-padding - 2 * $size-grid-padding;

.block {
    display: flex;
    flex-wrap: wrap;
    margin-right: -$size-grid-padding;
    margin-left: -$size-grid-padding;

    --mix-grid-columns: 2;
    --mix-grid-reference-width: calc(100vw - #{$_tile-net-inset});

    @include tablet {
        --mix-grid-columns: 3;
    }

    @include desktop {
        --mix-grid-columns: 6;
        // Subtract the sidebar and the net inset so the reference width equals
        // the real block width in padded full-width contexts at every viewport size.
        --mix-grid-reference-width: min(
            calc(100vw - #{$size-large-side-bar} - #{$_tile-net-inset}),
            #{$s-mw - $_tile-net-inset}
        );
    }

    &Padded {
        @include sidePadding;
    }
}

.tile {
    box-sizing: border-box;
    flex: 0 0 calc(var(--mix-grid-reference-width) / var(--mix-grid-columns));
    padding: 0 $size-grid-padding;
    margin-bottom: $size-grid-padding * 2;
}

.scroll {
    @include scrollableWrapper;

    &MobileOnly {
        padding: 0;
        .tile {
            box-sizing: content-box;
            flex-basis: 35%;

            &:first-of-type {
                margin-left: $size-grid-padding * 2;
            }
            &:last-of-type {
                padding-right: $size-grid-padding * 3;
            }

            @include tablet {
                flex-basis: 33.3333%;
            }

            @include desktop {
                box-sizing: border-box;
                flex-basis: 16.6666%;
                &:first-of-type {
                    margin-left: 0;
                }
                &:last-of-type {
                    padding-right: $size-grid-padding;
                }
            }
        }

        @include desktop {
            flex-wrap: wrap;
            &.blockPadded {
                @include sidePadding;
            }
        }
    }
}
</style>
